import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import Typography from '../typography/Typography';
const Label = props => {
    const [{ theme }] = useTheme();
    return React.createElement(Typography, { color: theme.palette.typography.secondary, ...props });
};
export default Label;
